import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment"
import { ItemAvatarFragment } from "@/components/items/avatar/ItemAvatar"
import { ItemLinkFragment } from "@/components/items/ItemLink"
import { ItemPreviewTooltipFragment } from "@/components/items/ItemPreviewTooltip/ItemPreviewTooltip.fragment"
import { ActivityFeedLiveTimestampFragment } from "../ActivityFeedLiveTimestamp.fragment"
import { ActivityFeedTypeIconFragment } from "../ActivityFeedTypeIcon.fragment"
import { ActivityFromFragment } from "../ActivityFrom.fragment"
import { ActivityPriceFragment } from "../ActivityPrice.fragment"
import { ActivityRarityFragment } from "../ActivityRarity.fragment"
import { ActivityToFragment } from "../ActivityTo.fragment"

export const ActivitySideBarFeedTableRowFragment = graphql(
  `
    fragment ActivitySideBarFeedTableRow on Activity {
      __typename
      id
      eventTime
      item {
        tokenId
        ...ItemLink
        ...ItemPreviewTooltip
        ...ItemAvatar
        ...ActivityRarity
      }
      collection {
        name
        slug
        imageUrl
        isVerified
        ...CollectionPreviewTooltip
      }
      ...ActivityFeedTypeIcon
      ...ActivityFeedLiveTimestamp
      ...ActivityTo
      ...ActivityFrom
      ...ActivityPrice
    }
  `,
  [
    ItemLinkFragment,
    ActivityFeedTypeIconFragment,
    ActivityFeedLiveTimestampFragment,
    ActivityToFragment,
    ActivityFromFragment,
    ActivityPriceFragment,
    ItemAvatarFragment,
    ActivityRarityFragment,
    ItemPreviewTooltipFragment,
    CollectionPreviewTooltipFragment,
  ],
)
